import OctopusIcon from '@assets/images/icons/octopus/base.svg?react'
import cx from 'classnames'
import type React from 'react'
import { useEffect } from 'react'

import { type GtmTriggerName, sendGtmEvent } from '../../../../constants/gtm'
import {
  isProPlan,
  isTeamPlan,
  PLAN_AGENCY,
} from '../../../../constants/userSubscriptionPlans'
import css from './PlanUpdated.module.scss'

interface Props {
  closeButton: React.ReactNode
  planId: string
  gtagId: GtmTriggerName
  onViewed: () => void
  title: string
  text: string
  children: React.ReactNode
}

export const PlanUpdatedLayout: React.FC<Props> = ({
  closeButton,
  planId,
  gtagId,
  onViewed,
  title,
  text,
  children,
}) => {
  useEffect(() => {
    sendGtmEvent(gtagId, 'Plan updated')
    onViewed()
  }, [onViewed])

  return (
    <div className={css.container}>
      <button className={css.closeBtn}>{closeButton}</button>

      <div className={css.header}>
        <div
          className={cx(css.iconWrap, {
            [css.pro]: isProPlan(planId),
            [css.team]: isTeamPlan(planId),
            [css.agency]: planId === PLAN_AGENCY,
          })}
        >
          <OctopusIcon />
        </div>
        <h5 className={css.title}>{title}</h5>
        <p className={css.text}>{text}</p>
      </div>

      <div className={css.action}>{children}</div>
    </div>
  )
}
